<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :default-sort="defaultSort" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :tooltip-config="{ contentMethod: false, enterable: true }" @sort-change="sortChange" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <!-- 工单编号 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Number')" prop="workNo">
              <BjInput v-model="queryParams.workNo" :placeholder="$t('workOrderList.Number')" comma @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <!-- 部门 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WorkorderType.table.InquiryType')" prop="consultType">
              <BjSelectLov v-model="queryParams.consultType" :option-list="consultNameList" @change="getNextList" :placeholder="$t('WorkorderType.table.InquiryType')"/>
            </el-form-item>
          </el-col>
          <!-- 服务 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.service')" prop="workOrderTypeId">
              <BjSelectLov :disabled="!queryParams.consultType" v-model="queryParams.workOrderTypeId" :placeholder="$t('workOrderList.service')" :option-list="workOrderTypeIdList"/>
            </el-form-item>
          </el-col>
          <!-- 创建时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.createTimeText')">
              <BjDateRangePicker v-model="queryParams_createTime" :placeholder="$t('table.createTimeText')" />
            </el-form-item>
          </el-col>
          <!-- 完成时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Completion')">
              <BjDateRangePicker v-model="queryParams_endTime" :placeholder="$t('workOrderList.Completion')" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:beforeSearchBtn v-if="!closeType">
          <el-col :span="24 - colSpan">
            <el-tabs :value="tabIndex" type="card" @tab-click="handleTabClick">
              <el-tab-pane v-for="(item, index) in CSG_WORK_ORDER_LIST_USER_OPEN" :key="index" :label="$t(item.label)" :name="item.value" />
            </el-tabs>
          </el-col>
        </template>
        <template v-slot:beforeSearchBtn v-else>
          <el-col :span="24 - colSpan">
            <el-tabs :value="tabIndex" type="card" @tab-click="handleTabClick">
              <el-tab-pane v-for="(item, index) in CSG_WORK_ORDER_LIST_USER_CLOSE" :key="index" :label="$t(item.label)" :name="item.value" />
            </el-tabs>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" @click="onAdd">{{ $t('addText') }}</el-button>
            <BjFrontendExport
              type="primary"
              :label-list="exportLabelList"
              :rows="selectedRows"
              file-name="workOrders.csv"
            />
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column
              v-if="col.prop !== 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || false"
              align="center"
              class-name="item"
            >
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'exigency'">
                  <el-tag v-if="scope.row.exigency">{{ scope.row[col.prop] ? $t(CSG_WORK_ORDER_EXIGENCY.bjGet(scope.row[col.prop])) : '' }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'status'">
                  <el-tag>{{ $t(CSG_WORK_ORDER_STATUS_USER.bjGet(scope.row[col.prop])) }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'pause'">
                  <el-tag v-if="scope.row.pause">{{ scope.row[col.prop] ? $t(CSG_WORK_ORDER_PAUSE.bjGet(scope.row[col.prop])) : '' }}</el-tag>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-dropdown :disabled="[5,7,9].includes(props.row.status)" v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="[1,2,6].includes(props.row.status)" command="edit">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[1].includes(props.row.status)" command="delete"> {{ $t('delText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[1,6].includes(props.row.status)" command="submit"> {{ $t('workOrderList.WOSubmit') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[2,3,6].includes(props.row.status)" command="invalid"> {{ $t('workOrderList.to') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { workorderApi } from '@/api';
  import {
    CSG_WORK_ORDER_LIST_USER_OPEN,
    CSG_WORK_ORDER_LIST_USER_CLOSE,
    CSG_WORK_ORDER_STATUS_USER,
    CSG_WORK_ORDER_PAUSE,
    CSG_WORK_ORDER_EXIGENCY,
  } from '@/utils/constants';
  import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
  
  export default {
    name: 'BusinessWorkorderListUser',
    components: { BjSelectCustomer },
    mixins: [pageMiXin],
    props: {
      closeType: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selection: true,
        colSpan: 4,
        CSG_WORK_ORDER_LIST_USER_OPEN,
        CSG_WORK_ORDER_LIST_USER_CLOSE,
        CSG_WORK_ORDER_STATUS_USER,
        CSG_WORK_ORDER_PAUSE,
        CSG_WORK_ORDER_EXIGENCY,
        queryApi: workorderApi.getWorkOrderPageList,
        // 查询参数
        queryParams_createTime: [],
        queryParams_endTime: [],
        queryParams: {
          consultType: null,
          workOrderTypeId: null,
          workNo: null,
          title: null,
          exigency: null,
          beginTime: null,
          endTime: null,
          completionTimeBegin: null,
          completionTimeEnd: null,
          cusId:this.$store.getters.cusId,
          status: this.closeType ? '5,7,9': '1,2,3,4,6'
        },
        tabIndex: '0',
        // 全部订单
        labelList1: [
          // { label: this.$t('workOrderList.Urgent'), prop: 'exigency', isCheck: true, disabled: false,},
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('workOrderList.Number'), prop: 'workNo', isCheck: true, disabled: false,},
          { label: this.$t('workOrderList.service'), prop: 'workOrderTypeName', isCheck: true, disabled: false,width: '115'},
          // { label: this.$t('workOrderList.title'), prop: 'title', isCheck: true, disabled: false,},
          { label: this.$t('workOrderList.Customer'), prop: 'customer', isCheck: true, disabled: false,},
          { label: this.$t('WorkorderType.table.InquiryType'), prop: 'consultType', isCheck: true, disabled: false,},
          // { label: this.$t('workOrderList.Operator'), prop: 'userName', isCheck: true, disabled: false,},
          { label: this.$t('workOrderList.state'), prop: 'status', isCheck: true, disabled: false,width: '160'},
          { label: this.$t('workOrderList.Creation'), prop: 'creationDate', isCheck: true, disabled: false,},
          // { label: this.$t('workOrderList.Review'), prop: 'auditTime', isCheck: true, disabled: false,width: '125'},
          // { label: this.$t('workOrderList.timeS'), prop: 'scheduledStartTime', isCheck: true, disabled: false,width: '125'},
          // { label: this.$t('workOrderList.timeE'), prop: 'scheduledEndTime', isCheck: true, disabled: false,width: '125'},
          { label: this.$t('workOrderList.Completion'), prop: 'completionTime', isCheck: true, disabled: false,},
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '130' },
        ],
        // 部门下拉列表
        consultNameList:[],
        // 服务下拉列表
        workOrderTypeIdList:[],
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
      exportLabelList() {
        const dateExport = { dateFormat: 'DD/MM/YYYY HH:mm' };
        return [
          { label: this.$t('workOrderList.Urgent'), prop: 'exigency', export: { options: CSG_WORK_ORDER_EXIGENCY, translate: true } },
          { label: this.$t('workOrderList.Number'), prop: 'workNo' },
          { label: this.$t('workOrderList.service'), prop: 'workOrderTypeName' },
          { label: this.$t('workOrderList.title'), prop: 'title' },
          { label: this.$t('workOrderList.Customer'), prop: 'customer' },
          { label: this.$t('workOrderList.Operations'), prop: 'operationDepartment' },
          { label: this.$t('workOrderList.Operator'), prop: 'userName' },
          { label: this.$t('workOrderList.state'), prop: 'status', export: { options: CSG_WORK_ORDER_STATUS_USER, translate: true } },
          { label: this.$t('workOrderList.Creation'), prop: 'creationDate', export: dateExport },
          { label: this.$t('workOrderList.Review'), prop: 'auditTime', export: dateExport },
          { label: this.$t('workOrderList.timeS'), prop: 'scheduledStartTime', export: dateExport },
          { label: this.$t('workOrderList.timeE'), prop: 'scheduledEndTime', export: dateExport },
          { label: this.$t('workOrderList.Completion'), prop: 'completionTime', export: dateExport },
        ];
      },
    },
    watch: {
      queryParams_createTime(v) {
        this.queryParams.beginTime = (v || [])[0];
        this.queryParams.endTime = (v || [])[1];
      },
      queryParams_endTime(v) {
        this.queryParams.completionTimeBegin = (v || [])[0];
        this.queryParams.completionTimeEnd = (v || [])[1];
      },
    },
    created(){
      // 获取部门下拉数据
      this.getWorkOrderConsultType()
    },
    mounted() {
      this.$store.dispatch('values/getTags');
      this.$nextTick(()=>{
        if(this.$route.query.tabIndex){
          this.handleTabClick({name: this.$route.query.tabIndex})
        }
      })
    },
    methods: {
      // 获取部门下拉数据
      getWorkOrderConsultType(){
        workorderApi.getConsultationTypeList().then(res=>{
          this.consultNameList = res.content.map(item => {
            return { label: item.consultName, value: item.consultName };
          });
        })
      },
      // 获取服务下拉数据
      getNextList(n,m){
        this.queryParams.workOrderTypeId = null
        workorderApi.ordertypeList({
          consultName: n,
          prohibits: 1,
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res=>{
          this.workOrderTypeIdList = res.content.map(e=>{
              return {label : e.name,value : e.id}
          })
        })
      },
      // tab页点击事件
      handleTabClick(tab, event) {
        this.tabIndex = tab.name;
        this.queryParams_createTime = null;
        this.queryParams_endTime = null;
        this.queryParams={
          consultType: null,
          workOrderTypeId: null,
          workNo: null,
          title: null,
          exigency: null,
          beginTime: null,
          endTime: null,
          completionTimeBegin: null,
          completionTimeEnd: null,
          cusId:this.$store.getters.cusId,
        }
        if(this.closeType){
          if(tab.name == '0'){
            this.queryParams.status = '5,7,9'
          }else if(tab.name == '5'){
            this.queryParams.status = '5,9'
          }else{
            this.queryParams.status = tab.name
          }
        }else{
          if(tab.name == '0'){
            this.queryParams.status = '1,2,3,4,6'
          }else{
            this.queryParams.status = tab.name
          }
        }
        setTimeout(() => { this.reFresh(); }, 500);
      },
      // 新增
      onAdd(){
        this.$router.push({
          name: 'BusinessWorkorderListForm',
          query: { type: 'add' },
        });
      },
      // 跳转详情
      onView(item) {
        this.$router.push({
          name: 'BusinessWorkorderListForm',
          query: { id: item.id,type: 'view' },
        });
      },
      command(text, row) {
        switch (text) {
            case 'edit':
                this.$router.push({
                  name: 'BusinessWorkorderListForm',
                  query: { id: row.id,type: 'edit' },
                });
                break;
            case 'delete':
                this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.delWorkOrder(row)
                })
                break;
            case 'submit':
                this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.submitWorkOrder(row)
                })
                break;
            case 'invalid':
                this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.invalidWorkOrder(row)
                })
                break;
            }
      },
      // 删除
      delWorkOrder(row){
        workorderApi.deleteWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 提交审核
      submitWorkOrder(row){
        workorderApi.startAuditWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 作废
      invalidWorkOrder(row){
        workorderApi.invalidWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParams_createTime = null;
        this.queryParams_endTime = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>

  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
